import { z } from 'zod';
import {
  SignalCategorySchema,
  SignalRankSchema,
  SignalStageSchema,
  SignalStatusSchema,
  BlockedReasonSchema,
} from '@terra/shared-schemas-orchestrator';

export const SignalUpdateInputSchema = z.object({
  stage: SignalStageSchema.optional(),
  status: SignalStatusSchema.nullable().optional(),
  blockedReason: BlockedReasonSchema.nullable().optional(),
  rank: SignalRankSchema.optional(),
  category: SignalCategorySchema.optional(),
  cweIds: z.array(z.string()).optional(),
  owaspCategory: z.string().nullable().optional(),
  assigneeId: z.string().nullable().optional(),
  note: z.string().optional(),
  description: z.string().nullable().optional(),
  analysis: z.string().nullable().optional(),
  confidence: z.int().min(1).max(5).nullable().optional(),
  reason: z.string().nullable().optional(),
  smokeTestSummary: z.string().nullable().optional(),
  lastSmokeTestedAt: z.coerce.date().nullable().optional(),
  securityTestCaseSummary: z.string().nullable().optional(),
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),
  endpointId: z.string().nullable().optional(),
  harEntryId: z.string().nullable().optional(),
  entryPointId: z.string().nullable().optional(),
});

export type SignalUpdateInput = z.infer<typeof SignalUpdateInputSchema>;
